export const themeResolver = () => {
  const prefesColorScheme = matchMedia("(prefers-color-scheme: light)");

  if (prefesColorScheme.matches) {
    return "dark";
  }
  return "light";
};

export const apiUrlByEnviroment = {
  development: process.env.VUE_APP_URL_API,
  production: process.env.VUE_APP_URL_API,
};

export const api2UrlByEnviroment = {
  development: process.env.VUE_APP_URL_APIV2,
  production: process.env.VUE_APP_URL_APIV2,
};
